import DownloadIcon from '@mui/icons-material/Download';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import PostAddIcon from '@mui/icons-material/PostAdd';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { FEATURES } from '../../../../config/features';

export function SettingInit({
  user,
  generateDownloadTemplate,
  openSelectDataLogs,
  openRevertTimeForm,
  openProcessTimeForm,
  openPostTimeForm,
  openDeleteAll,
  openUploadFormHandleClick,
}) {
  const handleUploadClick = () => {
    openUploadFormHandleClick();
  }

  return (
    <div id='payroll-setting' className="payroll-setting column">
      <div className="payroll-setting-item row" onClick={() => generateDownloadTemplate(false)}>
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><DownloadIcon /></div>
        Download Template
      </div>
      <div className="payroll-setting-item row" onClick={() => openSelectDataLogs()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#29aec5" }}><MenuBookIcon /></div>
        Select Data Logs
      </div>

      {FEATURES.TIMEKEEPING_TIMEENTRIES_UPLOAD && (
        <div className="payroll-setting-item row" onClick={() => handleUploadClick()}>
          <div style={{ margin: "10px 5px 0 5px", color: "#47d147" }}><FileUploadIcon /></div>
          Upload Time Entries
        </div>
      )}
      
      {user.username === "admin" && <div className="payroll-setting-item row" onClick={() => openDeleteAll()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#ff4d4d" }}><DeleteSweepIcon /></div>
        Delete All Uploaded Time Entries
      </div>
      }
      <div className="payroll-setting-item row" onClick={() => openRevertTimeForm()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#ff4d4d" }}><SettingsBackupRestoreIcon /></div>
        Revert Time Entries
      </div>
      <div className="payroll-setting-item row" onClick={() => openProcessTimeForm()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#ffaa00" }}><AccountTreeIcon /></div>
        Process Time Entries
      </div>
      <div className="payroll-setting-item row" onClick={() => openPostTimeForm()}>
        <div style={{ margin: "10px 5px 0 5px", color: "#1a75ff" }}><PostAddIcon /></div>
        Post Time Entries
      </div>
    </div>
  )
}